import { format, formatInTimeZone } from 'date-fns-tz';

export interface TimePreferences {
  time_zone: string;
  preferred_days: string[];
  preferred_times: string[];
  notice_period: string;
  virtual_preferred: boolean;
}

export function formatTimeWithZone(date: Date | string, time: string, timeZone: string = 'UTC'): string {
  // Combine date and time into a single Date object
  const dateTime = new Date(`${date}T${time}`);
  
  // Format in the specified timezone
  return formatInTimeZone(dateTime, timeZone, 'h:mm a zzz');
}

export function getUserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function convertTimeToZone(date: string, time: string, fromZone: string, toZone: string): string {
  const dateTime = new Date(`${date}T${time}`);
  return formatInTimeZone(dateTime, toZone, 'HH:mm');
}

export const TIME_PERIODS = [
  { label: 'Morning (9am-12pm)', value: 'morning' },
  { label: 'Afternoon (12pm-5pm)', value: 'afternoon' },
  { label: 'Evening (5pm-8pm)', value: 'evening' }
];

export const WEEKDAYS = [
  'Monday',
  'Tuesday', 
  'Wednesday',
  'Thursday',
  'Friday'
];